export function handleResponseError(error, errorAction) {
    let errors;
    let message = '';
    let isNetworkError = false; // Флаг для сетевой ошибки
    let statusCode = error.response?.status || null; // Код ответа сервера

    if (error.response) {
        errors = error.response.data?.errors;

        if (errors) {
            message = Object.values(errors).flat().join('\n');
        } else if (error.response.data?.error) { // 🛠 Берём `error` из ответа сервера
            message = error.response.data.error;
        } else if (error.response.data?.message) {
            message = error.response.data.message;
        } else {
            message = error.message || 'An error occurred.';
        }
    } else if (error.request) {
        // Обработка случаев с отсутствием ответа от сервера (например, сеть недоступна)
        message = `${error.message}. Please try later or reload the page.`;
        isNetworkError = true;
    } else {
        // Обработка всех других ошибок
        message = error.message || 'An error occurred.';
    }

    console.error(`Error (${statusCode}):`, message);

    const errorData = { errorMessage: message, isNetworkError, statusCode };
    errorAction.length === 1 ? errorAction(errorData.errorMessage) : errorAction(errorData);

}
